// İstanbul ilçe merkezi koordinatları (WGS84 ondalık derece)
// Koordinatı girilmemiş kayıtlar için yaklaşık konum (fallback) olarak kullanılır.
// Değerler ilçe belediye binaları baz alınarak doğrulandı (OSM/Nominatim) — hepsi KARA üzerindedir.

export const ILCE_KOORDINATLARI = {
  ADALAR: { lat: 40.8745, lon: 29.1326 },
  ARNAVUTKOY: { lat: 41.1855, lon: 28.7198 },
  ATASEHIR: { lat: 40.9974, lon: 29.1005 },
  AVCILAR: { lat: 40.9793, lon: 28.7122 },
  BAGCILAR: { lat: 41.0328, lon: 28.833 },
  BAHCELIEVLER: { lat: 40.9984, lon: 28.8513 },
  BAKIRKOY: { lat: 40.9811, lon: 28.8729 },
  BASAKSEHIR: { lat: 41.1209, lon: 28.7707 },
  BAYRAMPASA: { lat: 41.0348, lon: 28.9124 },
  BESIKTAS: { lat: 41.0502, lon: 29.0253 },
  BEYKOZ: { lat: 41.1271, lon: 29.0966 },
  BEYLIKDUZU: { lat: 41.0112, lon: 28.6499 },
  BEYOGLU: { lat: 41.0282, lon: 28.9735 },
  BUYUKCEKMECE: { lat: 41.0211, lon: 28.5848 },
  CATALCA: { lat: 41.1421, lon: 28.4574 },
  CEKMEKOY: { lat: 41.0331, lon: 29.1684 },
  ESENLER: { lat: 41.054, lon: 28.8677 },
  ESENYURT: { lat: 41.0284, lon: 28.6847 },
  EYUPSULTAN: { lat: 41.0433, lon: 28.9297 },
  FATIH: { lat: 41.0181, lon: 28.9408 },
  GAZIOSMANPASA: { lat: 41.0576, lon: 28.9152 },
  GUNGOREN: { lat: 41.0103, lon: 28.8749 },
  KADIKOY: { lat: 40.9934, lon: 29.0371 },
  KAGITHANE: { lat: 41.0712, lon: 28.9643 },
  KARTAL: { lat: 40.8901, lon: 29.1838 },
  KUCUKCEKMECE: { lat: 41.0354, lon: 28.7857 },
  MALTEPE: { lat: 40.9314, lon: 29.1279 },
  PENDIK: { lat: 40.8916, lon: 29.2646 },
  SANCAKTEPE: { lat: 40.9931, lon: 29.2282 },
  SARIYER: { lat: 41.1138, lon: 29.025 },
  SILIVRI: { lat: 41.0727, lon: 28.2556 },
  SULTANBEYLI: { lat: 40.971, lon: 29.2593 },
  SULTANGAZI: { lat: 41.1067, lon: 28.8722 },
  SILE: { lat: 41.1723, lon: 29.6084 },
  SISLI: { lat: 41.0659, lon: 28.9819 },
  TUZLA: { lat: 40.8435, lon: 29.3008 },
  UMRANIYE: { lat: 41.0283, lon: 29.0985 },
  USKUDAR: { lat: 41.0207, lon: 29.0196 },
  ZEYTINBURNU: { lat: 40.9964, lon: 28.909 },
  ISTANBUL: { lat: 41.0136, lon: 28.9497 },
};

// İstanbul il sınırını kapsayan güvenlik kutusu (bunun dışındaki koordinat hatalı sayılır)
export const ISTANBUL_BOUNDS = { latMin: 40.78, latMax: 41.68, lonMin: 27.9, lonMax: 29.95 };

// Türkçe karakter duyarsız normalize (İ→I, boşluklar silinir)
export const normalizeIlce = (str) => {
  if (!str) return '';
  return str
    .toString()
    .trim()
    .toUpperCase()
    .replace(/İ/g, 'I')
    .replace(/Ş/g, 'S')
    .replace(/Ğ/g, 'G')
    .replace(/Ü/g, 'U')
    .replace(/Ö/g, 'O')
    .replace(/Ç/g, 'C')
    .replace(/\s+/g, '');
};

// "41,008" veya "41.008" formatlarını sayıya çevirir
export const parseCoord = (v) => {
  if (v === null || v === undefined || v === '') return NaN;
  return parseFloat(String(v).trim().replace(',', '.'));
};

const inBounds = (lat, lon) => {
  const b = ISTANBUL_BOUNDS;
  return lat >= b.latMin && lat <= b.latMax && lon >= b.lonMin && lon <= b.lonMax;
};

// Basit deterministik hash (aynı kayıt her zaman aynı jitter'ı alır)
const hashCode = (str) => {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (h * 31 + str.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
};

/**
 * Kayıt için harita koordinatı çözer.
 * 1) Geçerli enlem/boylam İstanbul sınırları içindeyse onu kullanır (approx=false)
 * 2) Enlem/boylam ters girilmişse (ör. enlem=28.9, boylam=41.0) otomatik takas eder
 * 3) Koordinat yok/hatalıysa ilçe merkezine ~200 m'lik deterministik dağıtma uygular (approx=true)
 * 4) İlçe de eşleşmezse null döner (haritada gösterilmez)
 */
export const resolveCoords = (enlem, boylam, ilce, seed) => {
  let lat = parseCoord(enlem);
  let lon = parseCoord(boylam);
  if (isFinite(lat) && isFinite(lon)) {
    if (inBounds(lat, lon)) return { lat, lon, approx: false };
    if (inBounds(lon, lat)) return { lat: lon, lon: lat, approx: false }; // ters girilmiş
  }
  const merkez = ILCE_KOORDINATLARI[normalizeIlce(ilce)];
  if (!merkez) return null;
  const h = hashCode(String(seed || ''));
  const dLat = (((h % 1000) / 1000) - 0.5) * 0.0036; // ~ ±200 m
  const dLon = ((((Math.floor(h / 1000)) % 1000) / 1000) - 0.5) * 0.0048; // ~ ±200 m
  return { lat: merkez.lat + dLat, lon: merkez.lon + dLon, approx: true };
};
